import { LegalLayout, LegalSection } from "../components/LegalLayout";

// Public, logged-out information page: https://roadrnr.app/delete-account
export default function DeleteAccountInfo() {
  return (
    <LegalLayout title="Delete Account" updated="June 2026" testid="delete-account-info-page">
      <p>
        You can permanently delete your RoadRnr account at any time from within the
        app: go to <span className="font-semibold text-white/90">Profile &rsaquo; Delete account</span>.
      </p>

      <LegalSection heading="What gets deleted">
        <p>
          When you delete your account, your associated RoadRnr data is permanently
          removed. This includes your profile and profile image, your saved events,
          any events you created together with their images, your event boosts, and
          your banner ads and their images.
        </p>
      </LegalSection>

      <LegalSection heading="What we may retain">
        <p>
          A limited set of transaction and payment records may be legally retained
          for accounting, tax and compliance purposes, even after your account is
          deleted.
        </p>
      </LegalSection>

      <LegalSection heading="Can't access your account?">
        <p>
          If you are unable to access your account, you can request account and data
          deletion by emailing us at{" "}
          <a href="mailto:roadrnrapp@gmail.com" className="font-semibold text-[#ff2a00]">
            roadrnrapp@gmail.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
